import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "password",
    "confirmation",
    "submitButton",
    "length",
    "lengthIcon",
    "lengthLabel",
    "capital",
    "capitalIcon",
    "capitalLabel",
    "lowercase",
    "lowercaseIcon",
    "lowercaseLabel",
    "number",
    "numberIcon",
    "numberLabel",
    "match",
    "matchIcon",
    "matchLabel",
    "requirementsCard"
  ]

  static values = {
    loadingText: { type: String, default: "Saving..." }
  }

  connect() {
    this.validationState = {
      lowercase: false,
      capital: false,
      number: false,
      length: false,
      match: false
    }
    this.validate()

    if (this.hasSubmitButtonTarget) {
      this.originalButtonContent = this.submitButtonTarget.innerHTML
    }
  }

  preventCopyPaste(event) {
    event.preventDefault()
  }

  handleSubmit(event) {
    const isValid = Object.values(this.validationState).every(v => v)

    if (!isValid) {
      event.preventDefault()
      this.highlightUnmetRequirements()
      this.scrollToRequirements()
    } else {
      this.showLoadingState()
    }
  }

  showLoadingState() {
    if (!this.hasSubmitButtonTarget) return

    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.innerHTML = `
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      ${this.loadingTextValue}
    `
  }

  resetLoadingState() {
    if (!this.hasSubmitButtonTarget || !this.originalButtonContent) return

    this.submitButtonTarget.disabled = false
    this.submitButtonTarget.innerHTML = this.originalButtonContent
  }

  validate() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value

    this.validationState.lowercase = /[a-z]/.test(password)
    this.validationState.capital = /[A-Z]/.test(password)
    this.validationState.number = /[0-9]/.test(password)
    this.validationState.length = password.length >= 8
    this.validationState.match = password === confirmation && password !== ''

    this.updateValidationStatus("lowercase", this.validationState.lowercase)
    this.updateValidationStatus("capital", this.validationState.capital)
    this.updateValidationStatus("number", this.validationState.number)
    this.updateValidationStatus("length", this.validationState.length)
    this.updateValidationStatus("match", this.validationState.match)
  }

  updateValidationStatus(name, isValid) {
    const iconTarget = this[`${name}IconTarget`]
    const labelTarget = this[`${name}LabelTarget`]

    if (isValid) {
      iconTarget.classList.remove("fa-circle-xmark", "text-muted")
      iconTarget.classList.add("fa-circle-check", "text-success")
      labelTarget.classList.remove("text-muted")
      labelTarget.classList.add("text-success")
    } else {
      iconTarget.classList.remove("fa-circle-check", "text-success")
      iconTarget.classList.add("fa-circle-xmark", "text-muted")
      labelTarget.classList.remove("text-success")
      labelTarget.classList.add("text-muted")
    }
  }

  highlightUnmetRequirements() {
    const requirements = ['lowercase', 'capital', 'number', 'length', 'match']

    requirements.forEach(name => {
      if (!this.validationState[name]) {
        const target = this[`${name}Target`]
        target.classList.add('validation-highlight')

        setTimeout(() => {
          target.classList.remove('validation-highlight')
        }, 1000)
      }
    })
  }

  scrollToRequirements() {
    if (this.hasRequirementsCardTarget) {
      this.requirementsCardTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }
}
